module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_4.f96d0773.png";